/**
 * 将 FilterBar.vue 生成的 result
 *
    {
      city: ['id1'], // 单选结果
      district: ['id1', 'id2'], // 多选结果
      priceRange: [0, 55], // 价格范围 0~100
      ...
    }
 * 转换为筛选接口所需的格式
 *
 */
import CONFIG from '@/common/config'

export default (obj,type = 'rental') => {
  if (!obj || !Object.keys(obj).length) return {}
  const converted = {}
  for (let key in obj) {
    if (key === 'priceRange') {
      // 处理价格区间
      converted[key] = obj[key]
        .map(num => {
          // 1代表50，10代表500，...，100 代表不限(即0)
          return num === (type === 'rental' ? 50000 : 1000000) ? 0 : num
        })
        .join(',')

      if (converted[key] === '0,0') delete converted[key] // 价格不限
    } else if (key === 'other') {
      // 处理‘其他’一栏
      if (obj[key]) {
        const values = obj[key] // ['privateBathroom', 'allowSmoking' ...]
        values.forEach(valueName => {
          if (valueName === 'male' || valueName === 'female') {
            converted['gender'] = valueName
          } else {
            converted[valueName] = true
          }
        })
      }
      delete obj[key]
    } else if (obj[key]) {
      // 必须存在选中项

      if (!Array.isArray(obj[key])) {
        console.error(obj[key], 'is not an Array!')
        continue
      }
      // 选中项包含 any (id为-1)
      if (obj[key].includes('-1')) {
        // 不传此参数(即不限)
        continue
      }
      converted[key] = obj[key].join(',')
    }
  }

  return converted
}
